import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HT_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#HT_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HT_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HT_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 12v12h32V12H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M10 8h12v8H10z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "HT_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 10,
      y: 8,
      width: 12,
      height: 8
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M10 8h12v8H10z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#HT_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 14.578s2.88-.757 6-.711c3.12.046 6 .889 6 .889V16H10v-1.422z",
      fill: "#279E19"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.074 8.9s-.93-.419-1.58-.419-1.012.64-1.012.64",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.282 9.321s-.857-.306-1.455-.306c-.598 0-.93.467-.93.467",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.282 9.677s-.634-.307-1.076-.307c-.443 0-.688.468-.688.468",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.022 10.032s-.392-.306-.665-.306-.425.467-.425.467",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.987 10.274s-.157-.193-.266-.193c-.11 0-.17.295-.17.295M15.928 8.9s.93-.419 1.58-.419 1.012.64 1.012.64",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.72 9.321s.857-.306 1.455-.306c.598 0 .93.467.93.467",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.72 9.677s.634-.307 1.076-.307c.443 0 .688.468.688.468",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.98 10.032s.392-.306.665-.306c.274 0 .425.467.425.467",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.015 10.274s.157-.193.266-.193c.11 0 .17.295.17.295",
      stroke: "#026A16",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.888 10.398s-.115 1.337-.115 1.881.115 1.719.115 1.719h.293v-1.719c0-.454-.172-1.881-.172-1.881h-.121z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.732 11.919s-.724.388-.724 1.535l.724 1.386h1.307v-2.282l-1.307-.64z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.66 10.826s-1.691.501-1.691 2.349l2.19.187s-.12-1.074.555-1.57l-1.054-.966z",
      fill: "#0A328C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.96 10.121l2.901 2.658M11.955 10.723L16 13.35M11.258 11.74l4.56 2.085",
      stroke: "#FFD018",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.98 13.16l3.026.338-.17.423h-.48l.327.238.736.173v-.411h.646v.873h-1.382l-.53-.635s-.445.44-.88.44c-.434 0-.863-.143-.863-.622v-.333l-.43-.146v-.338z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.854 11.919s.724.388.724 1.535l-.724 1.386h-1.307v-2.282l1.307-.64z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.926 10.826s1.691.501 1.691 2.349l-2.19.187s.12-1.074-.555-1.57l1.054-.966z",
      fill: "#0A328C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.625 10.121l-2.9 2.658M19.63 10.723l-4.045 2.627M20.328 11.74l-4.56 2.085",
      stroke: "#FFD018",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.605 13.16l-3.025.338.17.423h.48l-.327.238-.737.173v-.411h-.645v.873h1.382l.53-.635s.445.44.88.44c.434 0 .863-.143.863-.622v-.333l.43-.146v-.338z",
      fill: "#FECA00"
    }
  ))))
);
export {
  t as default
};
